import React, { useEffect, useRef, useState, useCallback } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Nav from "./nav"

import "./style.less"
import MobileHeader from "./mobile"

const Header = ({ location, routeParams }) => {
  const [isShowNavMobile, setIsShowNavMobile] = useState(false)
  const [isVisibleQuoteButton, setIsVisibleQuoteButton] = useState(false)
  const headerComponent = useRef()

  const toggleMobileNav = useCallback(() => {
    const bodyRef = document.querySelector("body")

    isShowNavMobile
      ? bodyRef.style.removeProperty("position")
      : (bodyRef.style.position = "fixed")
    setIsShowNavMobile(!isShowNavMobile)
  }, [isShowNavMobile])

  const displayQuoteButton = useCallback(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisibleQuoteButton(!entry.isIntersecting)
    })
    observer.observe(headerComponent.current)
  }, [])

  useEffect(() => {
    displayQuoteButton()
    return () => {
      document.querySelector("body").style.removeProperty("position")
    }
  }, [displayQuoteButton])

  return (
    <header ref={headerComponent}>
      <div
        className={`w-full static ${
          isVisibleQuoteButton ? "sm:block" : "sm:hidden"
        }`}
      >
        <Link to={`/quote/`}>
          <div className="w-full flex justify-center font-bold get-a-quote fixed top-0 left-0 z-20 opacity-in qbutton">
            GET A QUOTE
          </div>
        </Link>
      </div>
      <div className="relative max-w-screen-reds-2xl m-auto sm:pt-4 px-7 lg:pb-0 pt-[70px]">
        <div className="flex flex-wrap justify-between w-full reds-border--none sm:reds-border--bottom pb-4">
          <div className="header--logo-layout flex justify-center w-auto sm:w-full xl:w-auto items-end">
            <Link className="sm:hidden" to={`/${routeParams?.location}/`}>
              <StaticImage
                width={116}
                src="../../static/images/icon/redsoda-logo-light.svg"
                alt="icon/redsoda-logo-light"
                formats={["auto", "webp", "avif"]}
              />
            </Link>
            <Link className="hidden sm:block" to={`/${routeParams?.location}/`}>
              <StaticImage
                width={236}
                src="../../static/images/icon/redsoda-logo-light.svg"
                alt="icon/redsoda-logo-light"
                formats={["auto", "webp", "avif"]}
              />
            </Link>
          </div>
          <div className="flex sm:hidden flex-wrap items-center">
            <button onClick={toggleMobileNav} className="flex items-center">
              <StaticImage
                src="../../../src/static/images/icon/nav-mobile-icon.svg"
                alt="icon/mobile-nav-icon"
              />
            </button>
          </div>

          <div className="hidden sm:flex justify-center w-full xl:w-auto flex-1">
            <Nav location={location} routeParams={routeParams} />
          </div>
        </div>
      </div>
      {isShowNavMobile && (
        <MobileHeader
          location={location}
          routeParams={routeParams}
          toggleMobileNav={toggleMobileNav}
        />
      )}
    </header>
  )
}

export default Header
